import React from "react";
import "../css/Home3.css";

const Home3 = () => {
  return (
    <div className="home3">

      {/* HERO SECTION */}
      <section className="home3-hero">
        <div className="home3-left">
          <div className="home3-text-box">
            <div className="vertical-box">
              <span>IT'S TIME TO</span>
            </div>

            <div className="title-box">
              <h1>OWN THE<br/>SEASON</h1>
            </div>
          </div>

          <div className="home3-btns">
            <button className="btn-dark">Start Now</button>
            <button className="btn-light">Discover More</button>
          </div>
        </div>

        <div className="home3-right">
          <img 
            src="https://images.pexels.com/photos/7991665/pexels-photo-7991665.jpeg"
            alt="Athlete"
          />
        </div>
      </section>


      {/* SECTION 2 — SHOWCASE */}
      <section className="home3-showcase">
        <div className="sc-left">
          <h2>BUILT FOR ATHLETES WITH PURPOSE</h2>
          <p>
            Precision-crafted workouts designed to break plateaus and elevate
            conditioning to elite levels.
          </p>
        </div>

        <div className="sc-right">
          <img src="https://images.unsplash.com/photo-1558611848-73f7eb4001a1" alt="Showcase" />
        </div>
      </section>


      {/* SECTION 3 — MARQUEE */}
      <section className="home3-marquee">
        <div className="marquee-track">
          <span>POWER • CONDITIONING • ENDURANCE • SEASON MODE • </span>
          <span>POWER • CONDITIONING • ENDURANCE • SEASON MODE • </span>
        </div>
      </section>


      {/* SECTION 4 — DEPTH CARDS */}
      <section className="home3-depth-cards">
        <div className="depth-card">
          <h3>FORM</h3>
          <p>Structural mastery through progressive overload.</p>
        </div>

        <div className="depth-card">
          <h3>FOCUS</h3>
          <p>Mind-muscle coordination sharpened each session.</p>
        </div>

        <div className="depth-card">
          <h3>FLOW</h3>
          <p>Rhythmic repetition unlocking deeper output potential.</p>
        </div>
      </section>


      {/* SECTION 5 — GIANT TYPOGRAPHY */}
      <section className="home3-giant-text">
        <h1>SEASON MODE: ACTIVATED</h1>
        <h2>Every rep. Every set. Every second counts.</h2>
      </section>


      {/* SECTION 6 — CUT IMAGE PANEL */}
      <section className="home3-cut-img">
        <div className="cut-overlay"></div>
        <img 
          src="https://images.unsplash.com/photo-1605296867304-46d5465a13f1"
          alt="Cut Art"
        />
        <div className="cut-text">
          <h1>TRAIN WITH PRECISION</h1>
        </div>
      </section>


      <section className="home3-masonry">
        <div className="masonry-grid">
      
          <div className="masonry-item tall" style={{backgroundImage:`url(https://images.unsplash.com/photo-1518611012118-696072aa579a)`}}></div>
      
          <div className="masonry-item" style={{backgroundImage:`url(https://images.unsplash.com/photo-1599058910811-f0c6a5d1e4f2)`}}></div>
      
          <div className="masonry-item wide" style={{backgroundImage:`url(https://images.unsplash.com/photo-1558611848-73f7eb4001a1)`}}></div>
      
          <div className="masonry-item" style={{backgroundImage:`url(https://images.unsplash.com/photo-1517838277536-f5f99be501cd)`}}></div>
      
          <div className="masonry-item" style={{backgroundImage:`url(https://images.unsplash.com/photo-1584466977773-e625c37cdd50)`}}></div>
      
          <div className="masonry-item tall" style={{backgroundImage:`url(https://images.unsplash.com/photo-1554284126-aa88f22d8b74)`}}></div>
      
        </div>
      </section>


      {/* NEW SECTION B — PERFORMANCE PILLARS */}
      <section className="home3-pillars">
        <div className="pillar">
          <h2>DISCIPLINE</h2>
          <p>Daily systems designed to sustain growth.</p>
        </div>

        <div className="pillar">
          <h2>INTENT</h2>
          <p>Every movement driven by purpose, not guesswork.</p>
        </div>

        <div className="pillar">
          <h2>RESILIENCE</h2>
          <p>Pushing through barriers with controlled intensity.</p>
        </div>
      </section>


      {/* NEW SECTION C — ATMOSPHERE PANEL */}
      <section className="home3-atmosphere">
        <img 
          src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438"
          alt="Gym Atmosphere"
        />
        <div className="atm-text">
          <h1>ENTER THE ARENA</h1>
          <p>Where motion, mindset, and mastery collide.</p>
        </div>
      </section>

    </div>
  );
};

export default Home3;
